<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip-comment-outline)">
      <path d="M3.83333 15.2857C3.75493 15.2857 3.676 15.268 3.60187 15.2327C3.41787 15.1432 3.00471 14.9563 3.00471 14.75C3.00471 14.75 3 13.5 3 13C3 12.5 3 12 2 12C1 12 0 11 0 10V2C0 1 1 0 2 0H14C15 0 16 1 16 2V10C16 11 15 12 14 12H8L4.16667 15.1684C4.07013 15.2461 3.95227 15.2857 3.83333 15.2857ZM2 1C1.5 1 1 1.5 1 2V10C1 10.5 1.5 11 2 11H3C3.5 11 4 11.5 4 12V14L7.5 11.1173C7.59493 11.0413 7.8784 11 8 11H14C14.5 11 15 10.5 15 10V2C15 1.5 14.5 1 14 1H2Z" fill="currentColor"/>
      <path d="M12.4444 6H3.55556C3.24833 6 3 5.776 3 5.5C3 5.224 3.24833 5 3.55556 5H12.4444C12.7517 5 13 5.224 13 5.5C13 5.776 12.7517 6 12.4444 6Z" fill="currentColor"/>
      <path d="M7.5 8.07143H3.5C3.2235 8.07143 3 7.83143 3 7.53571C3 7.24 3.2235 7 3.5 7H7.5C7.7765 7 8 7.24 8 7.53571C8 7.83143 7.7765 8.07143 7.5 8.07143Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip-comment-outline">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
name: "IconCommentOutline"
}
</script>

<style scoped>

</style>